import { PageLoader } from '@shared/ui/page-loader';
import { lazy, Suspense, useState } from 'react';
import { ResponsiveModal } from '@shared/ui/modal';
import type { CategoryId } from '@entities/category';

const Content = lazy(() => import('./settings-dialog').then((m) => ({ default: m.SettingsContent })));

export const SettingsDialog = ({
  opened,
  targetCategoryId,
  onClose,
}: {
  opened: boolean;
  targetCategoryId: CategoryId | null;
  onClose: () => void;
}) => {
  const [mounted, setMounted] = useState(opened);
  if (opened && !mounted) setMounted(true);
  if (!mounted) return null;
  return (
    <ResponsiveModal opened={opened} onClose={onClose} title="Настройки" closeLabel="Закрыть настройки">
      <Suspense fallback={<PageLoader compact label="Загружаем настройки" />}>
        <Content opened={opened} targetCategoryId={targetCategoryId} onClose={onClose} />
      </Suspense>
    </ResponsiveModal>
  );
};
